import React from "react";
import ContactUsImage from "../../assets/images/369X369.jpg";
const ContactImage = () => {
  return (
    <div className="col-md-6">
      <img src={ContactUsImage} alt="Contact Us" className="w-75" />
    </div>
  );
};

const handleInputFocus = (e) => {
  e.target.style.borderColor = "var(--primary-color)";
};

const handleInputBlur = (e) => {
  e.target.style.borderColor = "var(--third-color)";
};

const ContactUs = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // handle form submission here
  };

  return (
    <div className="container my-3">
      <div className="row d-flex justify-content-center align-items-center">
        <ContactImage />

        <div className="col-md-6">
          <h2
            className="text-center"
            style={{
              color: "var(--primary-color) ",
              fontWeight: "bold",
            }}
          >
            ارسل رسالة لاعضاء الحملة
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group mt-3">
              <label htmlFor="name" className="mb-2">
                {" "}
                الاسم
              </label>
              <input
                type="text"
                className="form-control shadow-none"
                id="name"
                name="name"
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                required
              />
            </div>
            <div className="form-group mt-3">
              <label htmlFor="email" className="mb-2">
                {" "}
                عنوان الرسالة
              </label>
              <input
                type="email"
                className="form-control shadow-none "
                id="email"
                name="email"
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                required
              />
            </div>
            <div className="form-group mt-3">
              <label htmlFor="message" className="mb-2">
                {" "}
                الرسالة
              </label>
              <textarea
                className="form-control shadow-none"
                id="message"
                name="message"
                rows="5"
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                required
              />
            </div>
            <div className="d-flex justify-content-end w-100">
              <button type="submit" className="btn btn-outline-success mt-3">
                ارسال عبر whatsapp
                <i className="fab fa-whatsapp mx-1"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
